import Logo from './logo.vue'
import Font from './font.vue'
import Template from './template.vue'
import Studio from './studio.vue'
import Person from './person.vue'
import Head from './head.vue'
import End from './end.vue'
import Music from './music.vue'
import Material from './material.vue'
import SubtitleTemplate from './subtitleTemplate.vue'

const Page = {
  [RESOURCE_TYPE.PASTER]: Logo,
  [RESOURCE_TYPE.FONT]: Font,
  [RESOURCE_TYPE.TEMPLATE]: Template,
  [RESOURCE_TYPE.STUDIO]: Studio,
  [RESOURCE_TYPE.PERSON]: Person,
  [RESOURCE_TYPE.HEAD]: Head,
  [RESOURCE_TYPE.END]: End,
  [RESOURCE_TYPE.MUSIC]: Music,
  [RESOURCE_TYPE.MATERIAL]: Material,
  [RESOURCE_TYPE.SUBTITLE_TEMPLATE]: SubtitleTemplate,
}

export default Page
